import PersonContactDialog from './PersonContactDialog.container';
export default PersonContactDialog;
